import React, { Component } from 'react';
import {Button,Card,CardBody,CardTitle,Col,FormGroup,Input,InputGroup,InputGroupButton,Label,Row} from 'reactstrap';

// Firebase
import { app } from '../../base';

class Dashboard extends Component {
  constructor() {
    super();
    this.state = {
      distance: '',
      edit_disabled: true,
      edit_switch: false,
      shop_display: 0,
      user_type: 0
    };

    this.checkUserType();
  }

  componentWillMount() {
    app.database().ref('settings').on('value', (snap)=>{
      let val = snap.val();
      this.setState({
        distance: val.distance,
        shop_display: val.shop_display
      });
    });
  }

  changeMode(event) {
    this.setState({
      edit_disabled: !event.target.checked,
      edit_switch: event.target.checked
    });
  }

  changeValue(e, params) {
    let value = e.target.value;
    this.setState({
      [params]: value
    });

    if (value == '') return;

    if (isNaN(value)) {
      alert('Must be a number');
    }
    else {
      value = parseInt(value); console.log(value);

      if (params == 'shop_display') {
        if(!e.target.checked) {
          value = 0
        }
      }

      let obj = {};
      obj[params] = value;
      app.database().ref('settings').update(obj);
    }
  }

  checkUserType() {
    setTimeout(()=>{
      let user_type = sessionStorage.getItem("user_type");
      if (user_type) {
        this.setState({
          user_type: user_type
        });
      }
      else {
        this.checkUserType();
      }
    }, 1000);
  }

  render() {
    let dashboardMsg = ['Loading...', 'Grocery Web Admin Panel', 'Shop User Panel', 'Delivery Man Panel']
    return (
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardBody>
                <Row>
                  <Col sm="5">
                    <CardTitle className="mb-0">{dashboardMsg[this.state.user_type]}</CardTitle>
                  </Col>
                </Row>
                <br />
                {(this.state.user_type == 1) &&
                  <div>
                    <CardBody className="p-1">
                  <Label className="switch switch-text switch-warning float-right">
                    <Input type="checkbox" className="switch-input" onClick={(e)=>this.changeMode(e)} checked={this.state.edit_switch}/>
                    <span className="switch-label" data-on="On" data-off="Off"></span>
                    <span className="switch-handle"></span>
                  </Label>
                </CardBody>
                    <Col xs="2">
                      <FormGroup>
                        <Label>Distance Parameter</Label>
                        <Input disabled={this.state.edit_disabled}
                          onChange={(e) => this.changeValue(e, "distance")}
                          placeholder="Enter in KM" type="text" value={this.state.distance}/>
                      </FormGroup>
                    </Col>
                    <Col xs="2">
                      <FormGroup>
                        <Label>
                          <Input disabled={this.state.edit_disabled}
                            checked={this.state.shop_display}
                            onChange={(e) => this.changeValue(e, "shop_display")}
                            type="checkbox" value="1"/> Shop Display
                        </Label>
                      </FormGroup>
                    </Col>
                  </div>
                }
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js